import { createContext, useContext, useState } from 'react';
import { useQueryParams } from '../../hooks/useQueryParams';

export enum EnhancementPanelTab {
  notes='Notes',
  illustrations='Illustrations',
  glossary='Glossary',
  discussion='Discussion'
};

export enum EnhancementPanelView {
  enhancement,
  collection,
  store
};

// export const PanelTabOrder: EnhancementPanelTab[] = [
//   EnhancementPanelTab.notes,
//   EnhancementPanelTab.illustrations,
//   EnhancementPanelTab.glossary,
//   EnhancementPanelTab.discussion
// ];

type EnhancementContextType = {
  areAnnotationsOn: boolean;
  setAnnotationsOn: () => void;
  setAnnotationsOff: () => void;
  isPanelOpen: boolean;
  openPanel: () => void;
  closePanel: () => void;

  tab: EnhancementPanelTab;
  setTab: (tab: EnhancementPanelTab) => void;

  activeEnhancementId: string;
  setActiveEnhancementId: (id: string) => void;

  enhancementDetail?: string;
  setEnhancementDetail: (detail: string) => void;

  view: EnhancementPanelView;
  setView: (tab: EnhancementPanelView) => void;
};

const EnhancementContext = createContext<EnhancementContextType>({
  areAnnotationsOn: true,
  setAnnotationsOn: () => {},
  setAnnotationsOff: () => {},
  isPanelOpen: false,
  openPanel: () => {},
  closePanel: () => {},
  tab: EnhancementPanelTab.notes,
  setTab: () => {},
  setEnhancementDetail: () => {},
  view: EnhancementPanelView.collection,
  setView: () => {},
  activeEnhancementId: '1',
  setActiveEnhancementId: () => {},
});

export const EnhancementProvider: React.FC = ({ children }) => {
  const {isPanelOpen: isPanelOpenParam} = useQueryParams()
  const [isPanelOpen, setPanelOpen] = useState(Boolean(isPanelOpenParam) || false);
  const openPanel = () => {
    setPanelOpen(true);
  };
  const closePanel = () => {
    setPanelOpen(false);
  };

  const [areAnnotationsOn, setAnnotationsStatus] = useState(true);
  const setAnnotationsOn = () => {
    setAnnotationsStatus(true);
  };
  const setAnnotationsOff = () => {
    setAnnotationsStatus(false);
  };

  const [tab, setTab] = useState<EnhancementPanelTab>(EnhancementPanelTab.notes);
  const [view, setView] = useState<EnhancementPanelView>(EnhancementPanelView.enhancement);
  const [enhancementDetail, setEnhancementDetail] = useState<string>();
  const [activeEnhancementId, setActiveEnhancementId] = useState<string>('1');

  return (
    <EnhancementContext.Provider
      value={{
        isPanelOpen,
        openPanel,
        closePanel,
        tab,
        setTab,
        areAnnotationsOn,
        setAnnotationsOn,
        setAnnotationsOff,
        enhancementDetail,
        setEnhancementDetail,
        view,
        setView,
        activeEnhancementId,
        setActiveEnhancementId
      }}>
      {children}
    </EnhancementContext.Provider>
  );
};

export const useEnhancement = () => useContext(EnhancementContext);
